import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";
import OBAPageIntroComponent from "../components/common/OBAPageIntroComponent";
import FacebookPageComponent from "../components/common/FacebookPageComponent";
import YouTubeComponent from "../components/common/YoutubeComponent";

import logo from "../assests/oba_logo_nbg.png";

export default function SocialMediaPage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <HeaderComponent user={null} />

      <main className="flex-grow-1 py-5">
        <div className="container">
          {/* Hero */}
          <OBAPageIntroComponent
            image={logo}
            title="News Feed"
            description="Stay up to date with the latest news, announcements, events, achievements, photographs, and videos from the Vidyaloka College Galle Old Boys' Association. Explore updates from all our official communication channels in one place."
          />
          {/* Facebook */}
          <section className="mb-5">
            <FacebookPageComponent />
          </section>

          {/* YouTube */}
          <section>
            <YouTubeComponent />
          </section>
        </div>
      </main>

      <FooterComponent />
    </div>
  );
}
